export default __webpack_public_path__ + "static/bad_gifgs_logo-ea4f37d75caade470f9f5f86844f4031.svg";